import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { dismissAnnouncement } from '../../../stores/announcements/actions';
import AdvancedAlert from '../../AdvancedAlert/AdvancedAlert';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 6,
  },
}));

const AnnouncmentItem = ({ details = {} }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { severity = 'default', dismissable = false, _id: id = '' } = details;

  function handleOnClick() {
    dispatch(dismissAnnouncement(id));
  }

  return (
    <AdvancedAlert
      className={classes.root}
      title={details.title}
      message={details.parsedMessage}
      link={details.link}
      linkLabel={details.linkLabel}
      variant={severity}
      onClose={dismissable ? handleOnClick : undefined}
    />
  );
};

export default AnnouncmentItem;
